import React, { useEffect } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import { defaultSelectStyles } from '@atlassian/jira-issue-field-select-base/src/ui/react-select-styles/styled.tsx';
import type { Props } from './types.tsx';

const IssueLinksType = (props: Props) => {
	const {
		options,
		value,
		onChange,
		autoFocus = false,
		onCloseMenuOnScroll,
		isDropdownMenuFixedAndLayered,
		isDisabled,
		inputId,
		isRequired,
		ariaLabel,
		ariaLabelledBy,
	} = props;

	useEffect(() => {
		if (value === undefined) {
			onChange(options[0]);
		}
	}, [value, onChange, options]);

	return (
		<Box xcss={linkTypeWrapperStyles}>
			<Select
				inputId={inputId}
				required={isRequired}
				options={options}
				value={value}
				// @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
				onChange={onChange}
				isMulti={false}
				autoFocus={autoFocus}
				defaultValue={options[0]}
				closeMenuOnScroll={onCloseMenuOnScroll}
				styles={defaultSelectStyles}
				menuPosition={isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined}
				isDisabled={isDisabled}
				classNamePrefix="issue-link-type"
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
			/>
		</Box>
	);
};

export default IssueLinksType;

const linkTypeWrapperStyles = xcss({
	width: '100%',
	marginBottom: 'space.100',
});
